export type ReportCatalogEntry = {
  name: string;
  path: string;
  description: string;
};

export type ReportCatalogGroup = {
  name: string;
  description: string;
  reports: ReportCatalogEntry[];
};

export const ACCOUNTING_REPORT_CATALOG: ReportCatalogGroup[] = [
  {
    name: 'Ledgers & journals',
    description: 'Posting detail, registers, and account ledgers',
    reports: [
      { name: 'Analytical ledgers', path: '/accounting/reports/analytical-ledgers', description: 'Browse accounts and drill into kartela' },
      { name: 'Journal register', path: '/accounting/reports/journal-register', description: 'Posted journals by period' },
      { name: 'Journal (lines)', path: '/accounting/reports/journal', description: 'Line-level journal extract' },
      { name: 'General ledger', path: '/accounting/reports/general-ledger', description: 'Account balances and movements' },
      { name: 'Link statement', path: '/accounting/reports/link-statement', description: 'Reconcile linked open items' },
    ],
  },
  {
    name: 'Trial balance',
    description: 'Period balances by account and company',
    reports: [
      { name: 'Trial balance', path: '/accounting/reports/trial-balance', description: 'Standard trial balance' },
      { name: 'Trial balance by company', path: '/accounting/reports/trial-balance-by-company', description: 'TB split by legal entity' },
    ],
  },
  {
    name: 'Open items',
    description: 'Receivables, payables, and aging',
    reports: [
      { name: 'Open items', path: '/accounting/reports/open-items', description: 'Outstanding AR/AP lines' },
      { name: 'Aging', path: '/accounting/reports/aging', description: 'Age analysis by due date' },
    ],
  },
  {
    name: 'Financial statements',
    description: 'P&L and balance sheet from statement lines',
    reports: [
      { name: 'Profit & loss', path: '/accounting/reports/profit-and-loss', description: 'Income statement' },
      { name: 'Balance sheet', path: '/accounting/reports/balance-sheet', description: 'Statement of financial position' },
    ],
  },
  {
    name: 'Analysis',
    description: 'Operational and management views',
    reports: [
      { name: 'Intercompany', path: '/accounting/reports/intercompany', description: 'Balances between companies' },
      { name: 'Running cost by vessel', path: '/accounting/reports/running-cost-by-vessel', description: 'Vessel P&L slice' },
      { name: 'Department analysis', path: '/accounting/reports/department-analysis', description: 'Costs by department' },
    ],
  },
  {
    name: 'Period close & audit',
    description: 'Close checklist and change history',
    reports: [
      { name: 'Period close checklist', path: '/accounting/reports/period-close-checklist', description: 'Pre-close validation' },
      { name: 'Audit trail', path: '/accounting/reports/audit-trail', description: 'Document and posting history' },
    ],
  },
];

export function flattenReportCatalogForSearch(): { label: string; path: string; group: string }[] {
  const out: { label: string; path: string; group: string }[] = [];
  for (const group of ACCOUNTING_REPORT_CATALOG) {
    for (const report of group.reports) {
      out.push({
        label: report.name,
        path: report.path,
        group: `Accounting › Reports › ${group.name}`,
      });
    }
  }
  return out;
}
